import { shrpaApi } from "./axios";

export interface NonPackagePrice {
  version: number;
  description: string;
  monthlyPrice: number;
  creatorVisitPrice: number;
}

export interface GeneralSubscriptionInfo {
  backendName: string;
  collabCount: number;
  frontendName: string;
  isRetired: boolean;
  lodgingAddonPriceId: string;
  stripePriceId: string;
  subscriptionId: string;
  yearlyPrice: number;
}

export interface CurrentSubscriptionData {
  billingEmail: string;
  canManageSubscriptionInStripe: boolean;
  collabsRemaining: number;
  isCancelling: boolean;
  isDisabled: boolean;
  isMonthly: boolean;
  isSpotlight: boolean;
  nextSubscriptionLevel: GeneralSubscriptionInfo | null;
  nonPackagePrice: NonPackagePrice | null;
  paymentStatus: string;
  stripePaymentLinkUri: string | null;
  subscriptionEndDate: string;
  subscriptionName: string;
  subscriptionPrice: number;
  isSubscriptionEndDatePast: boolean;
  totalCollabsForYearlySubscription: number;
  trialEndDate: null;
  subType: string;
}

export default {
  async getCurrentSubscription(customerId: string): Promise<CurrentSubscriptionData> {
    const { data } = await shrpaApi.get<CurrentSubscriptionData>(`/customers/${customerId}/subscriptions/current`);
    return data;
  },
};
